module.exports = __webpack_public_path__ + "img/child-bg.cc285c11.svg";